export default "__VITE_ASSET__CsRpFxFr__"